import { useFirstScreenAB } from './firstScreen/useFirstScreenAb';
// 券后价实验 AB实验 https://abtest-sgp.corp.kuaishou.com/ab2#/experiment/analysis/6988/detail?tab=2&docType=12&isShared=true

// 券后价实验推全
function usePriceAfterCoupon() {
    // const state = useFirstScreenAB();

    return {
        priceAfterCoupon: {
            showPriceUsedCouponStyle: true,
        },
    };
}

export default usePriceAfterCoupon;
